import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserSearchViewModel, SuperhogSearchResult, Trip } from 'models';
import { InterceptorsHeadersConfig, InterceptorsHeaders } from 'interceptors/config';

@Injectable({
    providedIn: 'root'
})
export class SearchService {
    constructor(private http: HttpClient) { }

    public search(searchString: string): Observable<SuperhogSearchResult> {
        return this.http.get<SuperhogSearchResult>('api/superhogsearch/search', {
            params: new HttpParams({
                fromObject: {
                    searchString: searchString || null
                }
            })
        });
    }

    public searchFromCache(cacheId: string): Observable<Trip> {
        return this.http.get<Trip>('api/superhogsearch/searchfromcache', {
            params: new HttpParams({
                fromObject: {
                    cacheId: cacheId || null
                }
            })
        });
    }

    public searchClients(
        searchString: string,
        config = <InterceptorsHeadersConfig>{
            disableLoaderInterceptor: false
        }
    ): Observable<UserSearchViewModel[]> {
        return this.http.get<UserSearchViewModel[]>('api/search/client', {
            params: new HttpParams({
                fromObject: {
                    searchString: searchString || null
                }
            }),
            ...(config.disableLoaderInterceptor && {
                headers: new HttpHeaders(<InterceptorsHeaders>{
                    'x-loader-interceptor': 'false'
                })
            })
        });
    }
}